import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

// Children
import DocumentView from "./single-enquiry-documents-view";

// Dialogues
import DialogueCreateDocumentPersonal from "routes/dashboard/dialogues/enquiries/create-document-personal";
import DialogueDeleteDocument from "routes/dashboard/dialogues/enquiries/delete-document";

// Actions
import { getAssociatedDocumentsPersonal } from "repository/actions/data/dashboard/enquiries";

export default withRouter(function (props) {
  const { enquiry, user } = props;

  const [documents, setDocuments] = useState(null);

  const [showNewDocumentDialogue, setShowNewDocumentDialogue] = useState(false);
  const [showDeleteDocumentDialogue, setShowDeleteDocumentDialogue] =
    useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Data Fetching
  useEffect(() => {
    if (user && user != null) {
      if (enquiry != null) {
        getAssociatedDocumentsPersonal(enquiry._id, user.idToken).then(
          (result) => {
            setDocuments(result.data);
          }
        );
      }
    }
  }, [enquiry]);

  // Editing Item
  let editingItem = null;
  if (documents) {
    if (documents[selectedIndex]) {
      editingItem = documents[selectedIndex];
    }
  }

  return (
    <div>
      <DocumentView
        loading={!documents}
        toggleAddCourseForm={() => setShowNewDocumentDialogue(true)}
        sectionDescription={
          "You can view and delete all related personal documents below."
        }
        documents={documents || []}
        setDocuments={setDocuments}
        enquiry={enquiry}
        onPressedDeleteItem={(index) => {
          setSelectedId(index);
          setShowDeleteDocumentDialogue(true);
        }}
        user={user}
      />
      <DialogueCreateDocumentPersonal
        isOpen={showNewDocumentDialogue}
        setClose={() => setShowNewDocumentDialogue(false)}
        documents={documents || []}
        setDocuments={setDocuments}
        enquiry={enquiry}
        user={user}
      />
      <DialogueDeleteDocument
        isOpen={showDeleteDocumentDialogue}
        setClose={() => setShowDeleteDocumentDialogue(false)}
        itemId={selectedId}
        documents={documents || []}
        setDocuments={setDocuments}
        user={user}
      />
    </div>
  );
});
